import {useEffect} from 'react';
import {useSelector} from 'react-redux';

import cacheService from '../services/cacheService';
import log from '../services/logger/log';
import uamClient from '../services/uam/uamClient';
import {selectIsAuthorized} from '../state/selectors/auth';

const useSyncImportantRequests = () => {
    const isUserAuthorized = useSelector(selectIsAuthorized);

    const processImportantRequest = async (request) => {
        const {data, url} = request || {};

        log.debug(`useSyncImportantRequests: Processing important request, url: ${url}`);

        try {
            await uamClient.callRequest(data);
            await cacheService.deleteCachedImportantRequest(url);

            log.debug(`useSyncImportantRequests: Request processed successfully, url: ${url}`);
        } catch (e) {
            log.error(`useSyncImportantRequests: Error processing request, url: ${url}`, e?.message);
        }
    };

    const syncImportantRequests = async () => {
        try {
            const cachedRequests = await cacheService.getCachedImportantRequests();

            if (!cachedRequests.length) return;

            log.debug('useSyncImportantRequests: Starting to process cached important requests');

            await Promise.all(cachedRequests.map(processImportantRequest));
        } catch (e) {
            log.error('useSyncImportantRequests: Error processing cached important requests', e?.message);
        }

        log.debug('useSyncImportantRequests: Finish processing cached important requests');
    };

    useEffect(() => {
        if (isUserAuthorized) {
            syncImportantRequests();
        }
    }, [isUserAuthorized]);
};

export default useSyncImportantRequests;
